/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../id_pair';
import '../date';
import '../location';
import '../buyer';
import '../creator_details';
import './client_details';
import '../../common/payment';
import './currency_exchange';
import '../../common/currency';
import '../../common/tipping';
import './translated_name';
import './cash_drawer_details';
import '../push/push';
import './card_data';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "bills": {
            "nested": {
              "Tender": {
                "fields": {
                  "tenderIdPair": {
                    "type": ".squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.client.bills.Tender.Type",
                    "id": 2,
                    "rule": "optional"
                  },
                  "readOnlyState": {
                    "type": ".squareup.client.bills.Tender.State",
                    "id": 3,
                    "rule": "optional"
                  },
                  "method": {
                    "type": ".squareup.client.bills.Tender.Method",
                    "id": 4,
                    "rule": "optional"
                  },
                  "tenderedAt": {
                    "type": ".squareup.client.ISO8601Date",
                    "id": 5,
                    "rule": "optional"
                  },
                  "amounts": {
                    "type": ".squareup.client.bills.Tender.Amounts",
                    "id": 6,
                    "rule": "optional"
                  },
                  "writeOnlyLocation": {
                    "type": ".squareup.client.GeoLocation",
                    "id": 7,
                    "rule": "optional"
                  },
                  "readOnlyBuyerProfile": {
                    "type": ".squareup.client.Buyer",
                    "id": 9,
                    "rule": "optional"
                  },
                  "readOnlyReceiptNumber": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "readOnlyLastRefundableAt": {
                    "type": ".squareup.client.ISO8601Date",
                    "id": 12,
                    "rule": "optional"
                  },
                  "creatorDetails": {
                    "type": ".squareup.client.CreatorDetails",
                    "id": 13,
                    "rule": "optional"
                  },
                  "writeOnlyClientCashDrawerShiftId": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "extraTenderDetails": {
                    "type": ".squareup.client.bills.Tender.CompleteTenderDetails",
                    "id": 16,
                    "rule": "optional"
                  },
                  "readOnlySequentialTenderNumber": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "readOnlyRefundCardPresenceRequirement": {
                    "type": ".squareup.client.bills.Tender.RefundCardPresenceRequirement",
                    "id": 18,
                    "rule": "optional",
                    "options": {
                      "default": "REFUND_CARD_PRESENCE_NOT_REQUIRED"
                    }
                  },
                  "tenderTag": {
                    "type": ".squareup.client.bills.TenderTag",
                    "id": 19,
                    "rule": "repeated"
                  },
                  "readOnlyLoyaltyDetails": {
                    "type": ".squareup.client.bills.Tender.LoyaltyDetails",
                    "id": 20,
                    "rule": "optional"
                  },
                  "clientDetails": {
                    "type": ".squareup.client.bills.ClientDetails",
                    "id": 21,
                    "rule": "optional"
                  },
                  "openTicketOwner": {
                    "type": ".squareup.client.CreatorDetails",
                    "id": 22,
                    "rule": "optional"
                  },
                  "peripheralMetadata": {
                    "type": ".squareup.common.payment.PeripheralMetadata",
                    "id": 23,
                    "rule": "optional"
                  },
                  "checkoutId": {
                    "type": "string",
                    "id": 24,
                    "rule": "optional"
                  },
                  "referenceId": {
                    "type": "string",
                    "id": 25,
                    "rule": "optional"
                  },
                  "createPaymentNote": {
                    "type": "string",
                    "id": 26,
                    "rule": "optional"
                  },
                  "checkoutAppId": {
                    "type": "string",
                    "id": 27,
                    "rule": "optional"
                  },
                  "readOnlyContactToken": {
                    "type": "string",
                    "id": 28,
                    "rule": "optional"
                  },
                  "revenueAssociationTags": {
                    "type": "string",
                    "id": 29,
                    "rule": "repeated"
                  },
                  "geoLocationType": {
                    "type": ".squareup.client.bills.Tender.GeoLocationType",
                    "id": 30,
                    "rule": "optional"
                  },
                  "buyerCurrencyExchange": {
                    "type": ".squareup.client.bills.CurrencyExchange",
                    "id": 32,
                    "rule": "optional"
                  },
                  "offlinePaymentMetadata": {
                    "type": ".squareup.client.bills.OfflinePaymentMetadata",
                    "id": 33,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "UNKNOWN": 0,
                      "CARD": 1,
                      "CASH": 2,
                      "NO_SALE": 3,
                      "OTHER": 4,
                      "WALLET": 5,
                      "GENERIC": 6,
                      "ZERO_AMOUNT": 7,
                      "EXTERNAL": 9,
                      "SQUARE_CAPITAL": 10,
                      "PUSH": 11,
                      "BANK_TRANSFER": 12,
                      "SQUARE_ACCOUNT": 13
                    }
                  },
                  "State": {
                    "values": {
                      "UNKNOWN_STATE": 0,
                      "LOST": 1,
                      "AWAITING_MERCHANT_TIP": 2,
                      "AWAITING_CUSTOMER_TIP": 3,
                      "SETTLED": 4
                    }
                  },
                  "Method": {
                    "fields": {
                      "cardTender": {
                        "type": ".squareup.client.bills.CardTender",
                        "id": 2,
                        "rule": "optional"
                      },
                      "cashTender": {
                        "type": ".squareup.client.bills.CashTender",
                        "id": 3,
                        "rule": "optional"
                      },
                      "noSaleTender": {
                        "type": ".squareup.client.bills.NoSaleTender",
                        "id": 4,
                        "rule": "optional"
                      },
                      "otherTender": {
                        "type": ".squareup.client.bills.OtherTender",
                        "id": 5,
                        "rule": "optional"
                      },
                      "walletTender": {
                        "type": ".squareup.client.bills.WalletTender",
                        "id": 6,
                        "rule": "optional"
                      },
                      "readOnlyGenericTender": {
                        "type": ".squareup.client.bills.GenericTender",
                        "id": 7,
                        "rule": "optional"
                      },
                      "zeroAmountTender": {
                        "type": ".squareup.client.bills.ZeroAmountTender",
                        "id": 8,
                        "rule": "optional"
                      },
                      "externalTender": {
                        "type": ".squareup.client.bills.ExternalTender",
                        "id": 10,
                        "rule": "optional"
                      },
                      "squareCapitalTender": {
                        "type": ".squareup.client.bills.SquareCapitalTender",
                        "id": 11,
                        "rule": "optional"
                      },
                      "pushTender": {
                        "type": ".squareup.client.bills.PushTender",
                        "id": 12,
                        "rule": "optional"
                      },
                      "squareAccountTender": {
                        "type": ".squareup.client.bills.SquareAccountTender",
                        "id": 13,
                        "rule": "optional"
                      }
                    }
                  },
                  "Amounts": {
                    "fields": {
                      "tipMoney": {
                        "type": ".squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "writeOnlyTaxMoney": {
                        "type": ".squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "totalMoney": {
                        "type": ".squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "tipPercentage": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "surchargeMoney": {
                        "type": ".squareup.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "autoGratuityMoney": {
                        "type": ".squareup.common.Money",
                        "id": 6,
                        "rule": "optional"
                      },
                      "autoGratuityPercentage": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "readOnlyReportingAmounts": {
                        "type": ".squareup.client.bills.Tender.Amounts.ReportingAmounts",
                        "id": 8,
                        "rule": "optional"
                      },
                      "cardSurchargeMoney": {
                        "type": ".squareup.common.Money",
                        "id": 9,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ReportingAmounts": {
                        "fields": {
                          "processingFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "processingFeeAmounts": {
                            "type": ".squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "ProcessingFeeAmounts": {
                            "fields": {
                              "squareProcessingFeeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "taxOnProcessingFeeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "squareProcessingFeeAmountDetails": {
                                "type": ".squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails",
                                "id": 3,
                                "rule": "optional"
                              },
                              "thirdPartyFeeAmountDetail": {
                                "type": ".squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail",
                                "id": 4,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "SquareProcessingFeeAmountDetails": {
                                "fields": {
                                  "initialFeeMoney": {
                                    "type": ".squareup.common.Money",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "initialTaxOnFeeMoney": {
                                    "type": ".squareup.common.Money",
                                    "id": 7,
                                    "rule": "optional"
                                  },
                                  "adjustmentFee": {
                                    "type": ".squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.AdjustmentFee",
                                    "id": 3,
                                    "rule": "repeated"
                                  },
                                  "feeType": {
                                    "type": ".squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeeType",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "feePlan": {
                                    "type": ".squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeePlan",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "freeProcessingFeeMoney": {
                                    "type": ".squareup.common.Money",
                                    "id": 6,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "AdjustmentFee": {
                                    "fields": {
                                      "money": {
                                        "type": ".squareup.common.Money",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "taxOnFeeMoney": {
                                        "type": ".squareup.common.Money",
                                        "id": 3,
                                        "rule": "optional"
                                      },
                                      "adjustedAt": {
                                        "type": ".squareup.client.ISO8601Date",
                                        "id": 2,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "FeeType": {
                                    "values": {
                                      "FIXED_RATE": 0,
                                      "COST_PLUS": 1
                                    }
                                  },
                                  "FeePlan": {
                                    "fields": {
                                      "discountBasisPoints": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "interchangeCents": {
                                        "type": "int64",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "taxRateBasisPoints": {
                                        "type": "int64",
                                        "id": 3,
                                        "rule": "optional"
                                      }
                                    }
                                  }
                                }
                              },
                              "ThirdPartyFeeAmountDetail": {
                                "fields": {
                                  "amount": {
                                    "type": ".squareup.common.Money",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "thirdPartyFeeEntity": {
                                    "type": ".squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeEntity",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "thirdPartyFeeServerToken": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "reversalDetail": {
                                    "type": ".squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeReversalDetail",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "thirdPartyAppDetail": {
                                    "type": ".squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyAppDetail",
                                    "id": 5,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "ThirdPartyFeeEntity": {
                                    "fields": {
                                      "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "displayName": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "unitName": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "ThirdPartyFeeReversalDetail": {
                                    "fields": {
                                      "linkedThirdPartyFeeServerToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "ThirdPartyAppDetail": {
                                    "fields": {
                                      "connectAppId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "CompleteTenderDetails": {
                    "fields": {
                      "receiptDisplayDetails": {
                        "type": ".squareup.client.bills.Tender.CompleteTenderDetails.ReceiptDisplayDetails",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ReceiptDisplayDetails": {
                        "fields": {
                          "displaySignatureLineOnPaperReceipt": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "displayTipOptionsOnPaperReceipt": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "tippingPreferences": {
                            "type": ".squareup.common.tipping.TippingPreferences",
                            "id": 3,
                            "rule": "optional"
                          },
                          "displayQuickTipOptions": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional"
                          },
                          "displayCustomAmount": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional"
                          },
                          "remainingTenderBalanceMoney": {
                            "type": ".squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "buyerSelectedLocale": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "buyerSignature": {
                            "type": ".squareup.common.payment.SignatureType",
                            "id": 8,
                            "rule": "optional",
                            "options": {
                              "default": "UNKNOWN"
                            }
                          },
                          "paperSignatureTipType": {
                            "type": ".squareup.client.bills.Tender.CompleteTenderDetails.ReceiptDisplayDetails.PaperSignatureTipType",
                            "id": 9,
                            "rule": "optional",
                            "options": {
                              "default": "UNSET"
                            }
                          }
                        },
                        "nested": {
                          "PaperSignatureTipType": {
                            "values": {
                              "UNSET": 0,
                              "TRADITIONAL": 1,
                              "QUICK_TIP": 2,
                              "GRATUITY_FREE": 3
                            }
                          }
                        }
                      }
                    }
                  },
                  "RefundCardPresenceRequirement": {
                    "values": {
                      "REFUND_CARD_PRESENCE_NOT_REQUIRED": 1,
                      "REFUND_CARD_PRESENCE_REQUIRED": 2
                    }
                  },
                  "LoyaltyDetails": {
                    "fields": {
                      "starsEarned": {
                        "type": "int32",
                        "id": 1,
                        "rule": "optional"
                      },
                      "rewardsEarned": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "newEnrollment": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "rewardName": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "reason": {
                        "type": ".squareup.client.bills.Tender.LoyaltyDetails.ReasonForNoStars",
                        "id": 5,
                        "rule": "optional"
                      },
                      "accountContact": {
                        "type": ".squareup.client.bills.Tender.LoyaltyDetails.AccountContact",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "AccountContact": {
                        "fields": {
                          "displayName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "contactToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "accountPhoneNumber": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "ReasonForNoStars": {
                        "values": {
                          "UNKNOWN": 0,
                          "SPEND_TOO_LOW": 1,
                          "NO_QUALIFYING_ITEMS": 2,
                          "SKIPPED_SCREEN": 3,
                          "NOT_YET_SUBSCRIBED": 4,
                          "CLIENT_DISABLED_LOYALTY": 5,
                          "RETURNED_FROM_RECEIPT_SCREEN": 6,
                          "RETURNED_FROM_LOYALTY_SCREEN": 7,
                          "BUYER_DECLINED": 8,
                          "OFFLINE_MODE": 9,
                          "NETWORK_TIMEOUT": 10,
                          "MISSING_LOYALTY_INFO": 11,
                          "RETURNED_DURING_LOADING": 12,
                          "PURCHASE_DID_NOT_QUALIFY": 13
                        }
                      }
                    }
                  },
                  "GeoLocationType": {
                    "values": {
                      "GEO_LOCATION_TYPE_UNSET": 0,
                      "SQUARE_DEVICE_ACCESS_POINT": 1,
                      "SQUARE_DEVICE_ETHERNET_GEOIP": 2
                    }
                  }
                }
              },
              "OfflinePaymentMetadata": {
                "fields": {
                  "clientCreatedAt": {
                    "type": ".squareup.client.ISO8601Date",
                    "id": 1,
                    "rule": "optional"
                  },
                  "uploadedAt": {
                    "type": ".squareup.client.ISO8601Date",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "TenderTag": {
                "fields": {
                  "key": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "value": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CardTender": {
                "fields": {
                  "card": {
                    "type": ".squareup.client.bills.CardTender.Card",
                    "id": 1,
                    "rule": "optional"
                  },
                  "readOnlyDelayCapture": {
                    "type": ".squareup.client.bills.CardTender.DelayCapture",
                    "id": 3,
                    "rule": "optional"
                  },
                  "readOnlyAuthorization": {
                    "type": ".squareup.client.bills.CardTender.Authorization",
                    "id": 4,
                    "rule": "optional"
                  },
                  "emv": {
                    "type": ".squareup.client.bills.CardTender.Emv",
                    "id": 5,
                    "rule": "optional"
                  },
                  "accountType": {
                    "type": ".squareup.client.bills.CardTender.AccountType",
                    "id": 6,
                    "rule": "optional"
                  },
                  "allowsReauthorizationWithChanges": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Card": {
                    "fields": {
                      "entryMethod": {
                        "type": ".squareup.client.bills.CardTender.Card.EntryMethod",
                        "id": 1,
                        "rule": "optional"
                      },
                      "brand": {
                        "type": ".squareup.client.bills.CardTender.Card.Brand",
                        "id": 2,
                        "rule": "optional"
                      },
                      "panSuffix": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "chipCardFallbackIndicator": {
                        "type": ".squareup.client.bills.CardTender.Card.ChipCardFallbackIndicator",
                        "id": 4,
                        "rule": "optional"
                      },
                      "writeOnlyCanSwipeChipCard": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      },
                      "felicaBrand": {
                        "type": ".squareup.client.bills.CardTender.Card.FelicaBrand",
                        "id": 6,
                        "rule": "optional"
                      },
                      "felicaMaskedCardNumber": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "felicaSprwid": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      },
                      "isAfterpayVirtualCard": {
                        "type": "bool",
                        "id": 9,
                        "rule": "optional"
                      },
                      "cardCoBrand": {
                        "type": ".squareup.client.bills.CardTender.Card.CardCoBrand",
                        "id": 10,
                        "rule": "optional"
                      },
                      "squareAccountPaymentToken": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Brand": {
                        "values": {
                          "UNKNOWN_BRAND": 1,
                          "VISA": 2,
                          "MASTERCARD": 3,
                          "AMERICAN_EXPRESS": 4,
                          "DISCOVER": 5,
                          "DISCOVER_DINERS": 6,
                          "JCB": 7,
                          "CHINA_UNIONPAY": 8,
                          "SQUARE_GIFT_CARD_V2": 9,
                          "INTERAC": 10,
                          "SQUARE_CAPITAL_CARD": 11,
                          "EFTPOS": 12,
                          "FELICA": 13,
                          "ALIPAY": 14,
                          "CASH_APP": 15,
                          "EBT": 16,
                          "PAYPAY": 17,
                          "AFTERPAY": 18,
                          "SQUARE_ACCOUNT_BALANCE": 19,
                          "RAKUTEN_PAY": 20,
                          "AU_PAY": 21,
                          "D_BARAI": 22,
                          "MERPAY": 23,
                          "WECHAT_PAY": 24
                        }
                      },
                      "EntryMethod": {
                        "values": {
                          "UNKNOWN_ENTRY_METHOD": 0,
                          "SWIPED": 1,
                          "KEYED": 2,
                          "EMV": 3,
                          "CONTACTLESS": 4,
                          "ON_FILE": 5
                        }
                      },
                      "ChipCardFallbackIndicator": {
                        "values": {
                          "NONE": 0,
                          "TECHNICAL": 1,
                          "SCHEME": 2
                        }
                      },
                      "FelicaBrand": {
                        "values": {
                          "DEFAULT_FELICA_BRAND_DO_NOT_USE": 0,
                          "FELICA_ID": 1,
                          "FELICA_TRANSPORTATION": 2,
                          "FELICA_QP": 3
                        }
                      },
                      "CardCoBrand": {
                        "values": {
                          "UNKNOWN_CO_BRAND": 0,
                          "AFTERPAY_CO_BRAND": 1,
                          "CLEARPAY_CO_BRAND": 2
                        }
                      }
                    }
                  },
                  "DelayCapture": {
                    "fields": {
                      "reason": {
                        "type": ".squareup.client.bills.CardTender.DelayCapture.Reason",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Reason": {
                        "values": {
                          "UNKNOWN": 0,
                          "TIP_ON_PAPER_RECEIPT": 1,
                          "REOPENABLE": 2,
                          "FULFILLMENT": 3
                        }
                      }
                    }
                  },
                  "Authorization": {
                    "fields": {
                      "authorizationCode": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "authorizedMoney": {
                        "type": ".squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "signatureOptionalMaxMoney": {
                        "type": ".squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "declineReason": {
                        "type": ".squareup.client.bills.CardTender.Authorization.DeclineReason",
                        "id": 4,
                        "rule": "optional"
                      },
                      "signatureBehavior": {
                        "type": ".squareup.client.bills.CardTender.Authorization.SignatureBehavior",
                        "id": 5,
                        "rule": "optional"
                      },
                      "pinToken": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "DeclineReason": {
                        "values": {
                          "DEFAULT_DO_NOT_USE": 0,
                          "CHIP_CARD_INSERTION_REQUIRED": 1,
                          "INVALID_PIN": 2,
                          "ALLOWABLE_PIN_TRIES_EXCEEDED": 3
                        }
                      },
                      "SignatureBehavior": {
                        "values": {
                          "DEFAULT_SIG_BEHAVIOR_DO_NOT_USE": 0,
                          "ISSUER_REQUEST_FOR_SIGNATURE": 1
                        }
                      }
                    }
                  },
                  "Emv": {
                    "fields": {
                      "readOnlyEncryptedEmvData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "writeOnlyProcessingType": {
                        "type": ".squareup.client.bills.CardTender.Emv.ProcessingType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "readOnlyChipCardApplicationId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "writeOnlyReaderFirmwareVersion": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "writeOnlyHardwareSerialNumber": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "readOnlyPlaintextEmvData": {
                        "type": "bytes",
                        "id": 6,
                        "rule": "optional"
                      },
                      "isEmvCapableReaderPresent": {
                        "type": "bool",
                        "id": 8,
                        "rule": "optional"
                      },
                      "readOnlyApplicationPreferredName": {
                        "type": "string",
                        "id": 9,
                        "rule": "optional"
                      },
                      "readOnlyCardholderVerificationMethodUsed": {
                        "type": ".squareup.client.bills.CardTender.Emv.CardholderVerificationMethod",
                        "id": 10,
                        "rule": "optional"
                      },
                      "readOnlyChipCardPreferredLanguageCode": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      },
                      "buyerSelectedAccountName": {
                        "type": "string",
                        "id": 12,
                        "rule": "optional"
                      },
                      "readOnlyChipCardApplicationTransactionCounter": {
                        "type": "string",
                        "id": 13,
                        "rule": "optional"
                      },
                      "readOnlyChipCardApplicationPrimaryAccountNumberSequenceNumber": {
                        "type": "string",
                        "id": 14,
                        "rule": "optional"
                      },
                      "readOnlyAuthorizationResponseCode": {
                        "type": "string",
                        "id": 15,
                        "rule": "optional"
                      },
                      "readOnlyPtagIssuerPinRequest": {
                        "type": "string",
                        "id": 16,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ProcessingType": {
                        "values": {
                          "UNKNOWN": 0,
                          "NOT_PROCESSED": 1,
                          "APPROVED_BY_READER_OFFLINE": 2
                        }
                      },
                      "CardholderVerificationMethod": {
                        "values": {
                          "DEFAULT_CVM_DO_NOT_USE": 0,
                          "NO_CVM": 1,
                          "SIGNATURE": 2,
                          "PIN": 3,
                          "PIN_AND_SIGNATURE": 4,
                          "ON_DEVICE": 5
                        }
                      }
                    }
                  },
                  "AccountType": {
                    "values": {
                      "UNKNOWN_ACCOUNT_TYPE": 0,
                      "SAVINGS": 1,
                      "CHECKING": 2,
                      "CREDIT": 3,
                      "EBT_CASH": 4,
                      "EBT_FOOD": 5
                    }
                  }
                }
              },
              "OtherTender": {
                "fields": {
                  "otherTenderType": {
                    "type": ".squareup.client.bills.OtherTender.OtherTenderType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "tenderNote": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "readOnlyTranslatedName": {
                    "type": ".squareup.client.bills.TranslatedName",
                    "id": 3,
                    "rule": "optional"
                  },
                  "externalMetadata": {
                    "type": ".squareup.client.bills.ExternalMetadata",
                    "id": 4,
                    "rule": "optional"
                  },
                  "source": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "sourceId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "OtherTenderType": {
                    "values": {
                      "UNKNOWN": 0,
                      "CHECK": 1,
                      "MERCHANT_GIFT_CARD": 2,
                      "DEBIT": 3,
                      "CREDIT_OR_DEBIT": 4,
                      "E_MONEY": 5,
                      "DEBIT_OR_CREDIT": 6,
                      "THIRD_PARTY_CARD": 7,
                      "MEAL_VOUCHER": 8,
                      "HACKWEEK_CRYPTO": 9,
                      "HOUSE_ACCOUNT": 10,
                      "VENMO": 11,
                      "BITCOIN": 12,
                      "CUSTOM": 100
                    }
                  }
                }
              },
              "ExternalMetadata": {
                "fields": {
                  "contentType": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "metadata": {
                    "type": "bytes",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GenericTender": {
                "fields": {
                  "settledBySquare": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "NoSaleTender": {
                "fields": {}
              },
              "CashTender": {
                "fields": {
                  "amounts": {
                    "type": ".squareup.client.bills.CashTender.Amounts",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cashDrawerDetails": {
                    "type": ".squareup.client.bills.CashDrawerDetails",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Amounts": {
                    "fields": {
                      "buyerTenderedMoney": {
                        "type": ".squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "changeBackMoney": {
                        "type": ".squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "WalletTender": {
                "fields": {}
              },
              "ZeroAmountTender": {
                "fields": {}
              },
              "ExternalTender": {
                "fields": {
                  "paymentSource": {
                    "type": ".squareup.client.bills.ExternalTender.PaymentSource",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PaymentSource": {
                    "fields": {
                      "applicationId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "applicationName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "PushTender": {
                "fields": {
                  "entryMethod": {
                    "type": ".squareup.client.bills.PushTender.EntryMethod",
                    "id": 2,
                    "rule": "optional"
                  },
                  "serverCompletedVersion": {
                    "type": ".squareup.client.push.ServerCompletedVersion",
                    "id": 6,
                    "rule": "optional"
                  },
                  "cashAppTender": {
                    "type": ".squareup.client.bills.CashAppTender",
                    "id": 1
                  },
                  "alipayTender": {
                    "type": ".squareup.client.bills.AlipayTender",
                    "id": 3
                  },
                  "paypayTender": {
                    "type": ".squareup.client.bills.PaypayTender",
                    "id": 4
                  },
                  "afterpayTender": {
                    "type": ".squareup.client.bills.AfterpayTender",
                    "id": 5
                  },
                  "rakutenPayTender": {
                    "type": ".squareup.client.bills.RakutenPayTender",
                    "id": 7
                  },
                  "auPayTender": {
                    "type": ".squareup.client.bills.AuPayTender",
                    "id": 8
                  },
                  "dBaraiTender": {
                    "type": ".squareup.client.bills.DBaraiTender",
                    "id": 9
                  },
                  "merpayTender": {
                    "type": ".squareup.client.bills.MerpayTender",
                    "id": 10
                  },
                  "wechatPayTender": {
                    "type": ".squareup.client.bills.WechatPayTender",
                    "id": 11
                  }
                },
                "nested": {
                  "EntryMethod": {
                    "values": {
                      "ENTRY_METHOD_DO_NOT_USE": 0,
                      "QR_CODE": 1,
                      "SMS": 2,
                      "REDIRECT": 3
                    }
                  },
                  "push_type": {
                    "oneof": ["cashAppTender", "alipayTender", "paypayTender", "afterpayTender", "rakutenPayTender", "auPayTender", "dBaraiTender", "merpayTender", "wechatPayTender"]
                  }
                }
              },
              "CashAppTender": {
                "fields": {
                  "authorizationCode": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "pwcTransactionId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "readOnlyCashtag": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "readOnlyBuyerFullName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "AlipayTender": {
                "fields": {
                  "alipayTransactionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "readOnlyReferenceBuyerId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PaypayTender": {
                "fields": {
                  "paypayTransactionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "readOnlyBuyerId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RakutenPayTender": {
                "fields": {
                  "rakutenPayTransactionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "AuPayTender": {
                "fields": {
                  "auPayTransactionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DBaraiTender": {
                "fields": {
                  "dBaraiTransactionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "MerpayTender": {
                "fields": {
                  "merpayTransactionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "WechatPayTender": {
                "fields": {
                  "wechatPayTransactionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "AfterpayTender": {
                "fields": {
                  "afterpayTransactionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "readOnlyBuyerEmail": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "readOnlyIsClearpayBranded": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SquareCapitalTender": {
                "fields": {
                  "secretKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "repaymentInstrument": {
                    "type": ".squareup.client.bills.SquareCapitalTender.CardInstrumentDetails",
                    "id": 2,
                    "rule": "optional"
                  },
                  "downPaymentAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CardInstrumentDetails": {
                    "fields": {
                      "instrumentToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cardholderName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "card": {
                        "type": ".squareup.client.bills.CardTender.Card",
                        "id": 3,
                        "rule": "optional"
                      },
                      "expirationDate": {
                        "type": ".squareup.client.bills.CardData.KeyedCard.Expiry",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "SquareAccountTender": {
                "fields": {
                  "squareAccountToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "contactToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "primaryDisplayName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.Type && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.State && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.Method && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.Amounts && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.SquareProcessingFeeAmountDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.SquareProcessingFeeAmountDetails?.nested?.AdjustmentFee && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.SquareProcessingFeeAmountDetails?.nested?.FeeType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.SquareProcessingFeeAmountDetails?.nested?.FeePlan && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.ThirdPartyFeeAmountDetail && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.ThirdPartyFeeAmountDetail?.nested?.ThirdPartyFeeEntity && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.ThirdPartyFeeAmountDetail?.nested?.ThirdPartyFeeReversalDetail && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.ThirdPartyFeeAmountDetail?.nested?.ThirdPartyAppDetail && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.CompleteTenderDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.CompleteTenderDetails?.nested?.ReceiptDisplayDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.CompleteTenderDetails?.nested?.ReceiptDisplayDetails?.nested?.PaperSignatureTipType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.RefundCardPresenceRequirement && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.LoyaltyDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.LoyaltyDetails?.nested?.AccountContact && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.LoyaltyDetails?.nested?.ReasonForNoStars && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Tender?.nested?.GeoLocationType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.OfflinePaymentMetadata && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.TenderTag && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.Card && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.Card?.nested?.Brand && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.Card?.nested?.EntryMethod && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.Card?.nested?.ChipCardFallbackIndicator && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.Card?.nested?.FelicaBrand && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.Card?.nested?.CardCoBrand && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.DelayCapture && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.DelayCapture?.nested?.Reason && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.Authorization && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.Authorization?.nested?.DeclineReason && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.Authorization?.nested?.SignatureBehavior && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.Emv && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.Emv?.nested?.ProcessingType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.Emv?.nested?.CardholderVerificationMethod && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardTender?.nested?.AccountType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.OtherTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.OtherTender?.nested?.OtherTenderType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ExternalMetadata && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GenericTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.NoSaleTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CashTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CashTender?.nested?.Amounts && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.WalletTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ZeroAmountTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ExternalTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ExternalTender?.nested?.PaymentSource && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.PushTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.PushTender?.nested?.EntryMethod && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CashAppTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.AlipayTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.PaypayTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.RakutenPayTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.AuPayTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.DBaraiTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.MerpayTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.WechatPayTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.AfterpayTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SquareCapitalTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SquareCapitalTender?.nested?.CardInstrumentDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SquareAccountTender) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Tender @ squareup/client/bills/tender.proto at 29:1
 */
export const Tender = $root.lookupType('squareup.client.bills.Tender');
fixType(Tender, {
  tenderIdPair: {
    required: true
  },
  type: {
    required: true
  },
  method: {
    required: true
  },
  tenderedAt: {
    required: true
  },
  amounts: {
    required: true
  }
});
Builder.createAndAttachToType(Tender);
/**
 * SOURCE Type @ squareup/client/bills/tender.proto at 33:3
 */
Tender.Type = $root.lookupEnum('squareup.client.bills.Tender.Type').values;
/**
 * Only tenders in these states are visible to merchant:
 * - LOST
 * - AWAITING_MERCHANT_TIP
 * - AWAITING_CUSTOMER_TIP
 * - SETTLED
 *
 * SOURCE State @ squareup/client/bills/tender.proto at 93:3
 */
Tender.State = $root.lookupEnum('squareup.client.bills.Tender.State').values;
/**
 * The populated tender method should match the type specified in type.
 * Only one field should be populated.
 *
 * SOURCE Method @ squareup/client/bills/tender.proto at 118:3
 */
Tender.Method = $root.lookupType('squareup.client.bills.Tender.Method');
fixType(Tender.Method);
Builder.createAndAttachToType(Tender.Method);
/**
 * Note that amounts here indicate that the tender will be charged (e.g. debit for bank accounts, charge
 * for payment card). Amounts should be positive.
 *
 * SOURCE Amounts @ squareup/client/bills/tender.proto at 155:3
 */
Tender.Amounts = $root.lookupType('squareup.client.bills.Tender.Amounts');
fixType(Tender.Amounts, {
  totalMoney: {
    required: true
  }
});
Builder.createAndAttachToType(Tender.Amounts);
/**
 * The following message is a copy of the server bill tender message of the same name
 *
 * SOURCE ReportingAmounts @ squareup/client/bills/tender.proto at 202:5
 */
Tender.Amounts.ReportingAmounts = $root.lookupType('squareup.client.bills.Tender.Amounts.ReportingAmounts');
fixType(Tender.Amounts.ReportingAmounts);
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts);
/**
 * This is the breakdown for processing_fee_money.
 * processing_fee_money = square_processing_fee_money + tax_on_processing_fee_money
 *
 * SOURCE ProcessingFeeAmounts @ squareup/client/bills/tender.proto at 210:7
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts = $root.lookupType('squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts);
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts);
/**
 * Additional breakdown of square_processing_fee_money. Set when a tender has fee adjustment.
 * The field is used for Cost+ as of 2016 Q3.
 *
 * The following invariant holds:
 *   initial_fee_money + sum(adjustment_fee_money) = square_processing_fee_money.
 *   intial_tax_on_fee_money + sum(adjustment_tax_on_fee_money) = tax_on_processing_fee_money
 *
 * SOURCE SquareProcessingFeeAmountDetails @ squareup/client/bills/tender.proto at 224:9
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails = $root.lookupType('squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails);
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails);
/**
 * An AdjustmentFee is composed of a fee, and a tax on the fee.
 * The total adjusted fee including tax is (money + tax_on_fee_money).
 * Tax on fee adjustments are only used for Cost+ AU as of Q4 2020.
 *
 * SOURCE AdjustmentFee @ squareup/client/bills/tender.proto at 240:11
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.AdjustmentFee = $root.lookupType('squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.AdjustmentFee');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.AdjustmentFee);
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.AdjustmentFee);
/**
 * Type of the fee.
 *
 * SOURCE FeeType @ squareup/client/bills/tender.proto at 266:11
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeeType = $root.lookupEnum('squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeeType').values;
/**
 * SOURCE FeePlan @ squareup/client/bills/tender.proto at 274:11
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeePlan = $root.lookupType('squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeePlan');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeePlan);
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeePlan);
/**
 * The breakdown of *non-Square* fees assessed on this tender.
 *
 * SOURCE ThirdPartyFeeAmountDetail @ squareup/client/bills/tender.proto at 292:9
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail = $root.lookupType('squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail, {
  amount: {
    required: true
  },
  thirdPartyFeeEntity: {
    required: true
  }
});
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail);
/**
 * Description of the entity that is the recipient of the above fee amount.
 *
 * SOURCE ThirdPartyFeeEntity @ squareup/client/bills/tender.proto at 302:11
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeEntity = $root.lookupType('squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeEntity');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeEntity, {
  unitToken: {
    notEmpty: true
  },
  displayName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeEntity);
/**
 * For reversal third party fees, contains a pointer to the original third party fee.
 *
 * SOURCE ThirdPartyFeeReversalDetail @ squareup/client/bills/tender.proto at 321:11
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeReversalDetail = $root.lookupType('squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeReversalDetail');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeReversalDetail, {
  linkedThirdPartyFeeServerToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeReversalDetail);
/**
 * For third party fees derived from app fees, the app developer's information. Populated by beemo.
 *
 * SOURCE ThirdPartyAppDetail @ squareup/client/bills/tender.proto at 327:11
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyAppDetail = $root.lookupType('squareup.client.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyAppDetail');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyAppDetail);
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyAppDetail);
/**
 * Extra tender details populated in CompleteTender for bill completion requests by client and copied
 * into Bill.Tender as-is by Omnibus.
 *
 * SOURCE CompleteTenderDetails @ squareup/client/bills/tender.proto at 393:3
 */
Tender.CompleteTenderDetails = $root.lookupType('squareup.client.bills.Tender.CompleteTenderDetails');
fixType(Tender.CompleteTenderDetails);
Builder.createAndAttachToType(Tender.CompleteTenderDetails);
/**
 * Used to generate duplicate receipts for re-printing and settling delayed tips.
 *
 * SOURCE ReceiptDisplayDetails @ squareup/client/bills/tender.proto at 397:5
 */
Tender.CompleteTenderDetails.ReceiptDisplayDetails = $root.lookupType('squareup.client.bills.Tender.CompleteTenderDetails.ReceiptDisplayDetails');
fixType(Tender.CompleteTenderDetails.ReceiptDisplayDetails);
Builder.createAndAttachToType(Tender.CompleteTenderDetails.ReceiptDisplayDetails);
/**
 * SOURCE PaperSignatureTipType @ squareup/client/bills/tender.proto at 436:7
 */
Tender.CompleteTenderDetails.ReceiptDisplayDetails.PaperSignatureTipType = $root.lookupEnum('squareup.client.bills.Tender.CompleteTenderDetails.ReceiptDisplayDetails.PaperSignatureTipType').values;
/**
 * Whether card presence is required for this tender to be refunded. If REQUIRED, then
 * the card needs to be presented to Register in order to request the refund.
 *
 * Default should be REFUND_CARD_PRESENCE_NOT_REQUIRED.
 *
 * SOURCE RefundCardPresenceRequirement @ squareup/client/bills/tender.proto at 495:3
 */
Tender.RefundCardPresenceRequirement = $root.lookupEnum('squareup.client.bills.Tender.RefundCardPresenceRequirement').values;
/**
 * For historical transactions, this indicates whether and how the buyer engaged with Square
 * Loyalty.
 *
 * SOURCE LoyaltyDetails @ squareup/client/bills/tender.proto at 514:3
 */
Tender.LoyaltyDetails = $root.lookupType('squareup.client.bills.Tender.LoyaltyDetails');
fixType(Tender.LoyaltyDetails, {
  starsEarned: {
    required: true
  },
  rewardsEarned: {
    required: true
  },
  newEnrollment: {
    required: true
  }
});
Builder.createAndAttachToType(Tender.LoyaltyDetails);
/**
 * The contact attached to the Loyalty Account that accrued the points for this transaciton
 *
 * SOURCE AccountContact @ squareup/client/bills/tender.proto at 519:5
 */
Tender.LoyaltyDetails.AccountContact = $root.lookupType('squareup.client.bills.Tender.LoyaltyDetails.AccountContact');
fixType(Tender.LoyaltyDetails.AccountContact);
Builder.createAndAttachToType(Tender.LoyaltyDetails.AccountContact);
/**
 * SOURCE ReasonForNoStars @ squareup/client/bills/tender.proto at 535:5
 */
Tender.LoyaltyDetails.ReasonForNoStars = $root.lookupEnum('squareup.client.bills.Tender.LoyaltyDetails.ReasonForNoStars').values;
/**
 * Type of geolocation method used for the tender
 *
 * SOURCE GeoLocationType @ squareup/client/bills/tender.proto at 643:3
 */
Tender.GeoLocationType = $root.lookupEnum('squareup.client.bills.Tender.GeoLocationType').values;
/**
 * SOURCE OfflinePaymentMetadata @ squareup/client/bills/tender.proto at 668:1
 */
export const OfflinePaymentMetadata = $root.lookupType('squareup.client.bills.OfflinePaymentMetadata');
fixType(OfflinePaymentMetadata);
Builder.createAndAttachToType(OfflinePaymentMetadata);
/**
 * SOURCE TenderTag @ squareup/client/bills/tender.proto at 679:1
 */
export const TenderTag = $root.lookupType('squareup.client.bills.TenderTag');
fixType(TenderTag, {
  key: {
    notEmpty: true
  },
  value: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TenderTag);
/**
 * SOURCE CardTender @ squareup/client/bills/tender.proto at 685:1
 */
export const CardTender = $root.lookupType('squareup.client.bills.CardTender');
fixType(CardTender, {
  card: {
    required: true
  }
});
Builder.createAndAttachToType(CardTender);
/**
 * SOURCE Card @ squareup/client/bills/tender.proto at 686:3
 */
CardTender.Card = $root.lookupType('squareup.client.bills.CardTender.Card');
fixType(CardTender.Card, {
  entryMethod: {
    required: true
  }
});
Builder.createAndAttachToType(CardTender.Card);
/**
 * SOURCE Brand @ squareup/client/bills/tender.proto at 687:5
 */
CardTender.Card.Brand = $root.lookupEnum('squareup.client.bills.CardTender.Card.Brand').values;
/**
 * SOURCE EntryMethod @ squareup/client/bills/tender.proto at 739:5
 */
CardTender.Card.EntryMethod = $root.lookupEnum('squareup.client.bills.CardTender.Card.EntryMethod').values;
/**
 * Indicates if register fell back to swiping or manual entry for EMV cards.
 * If this is not set to NONE, entry_method will be expected to be SWIPED or KEYED
 *
 * TECHNICAL: the card's chip has failed multiple times and the reader must fall back to swipe/keyed data.
 *
 * SCHEME: the reader failed to read the EMV chip's Application ID and must fall back to swipe/keyed data.
 *
 * SOURCE ChipCardFallbackIndicator @ squareup/client/bills/tender.proto at 770:5
 */
CardTender.Card.ChipCardFallbackIndicator = $root.lookupEnum('squareup.client.bills.CardTender.Card.ChipCardFallbackIndicator').values;
/**
 * SOURCE FelicaBrand @ squareup/client/bills/tender.proto at 791:5
 */
CardTender.Card.FelicaBrand = $root.lookupEnum('squareup.client.bills.CardTender.Card.FelicaBrand').values;
/**
 * SOURCE CardCoBrand @ squareup/client/bills/tender.proto at 815:5
 */
CardTender.Card.CardCoBrand = $root.lookupEnum('squareup.client.bills.CardTender.Card.CardCoBrand').values;
/**
 * SOURCE DelayCapture @ squareup/client/bills/tender.proto at 841:3
 */
CardTender.DelayCapture = $root.lookupType('squareup.client.bills.CardTender.DelayCapture');
fixType(CardTender.DelayCapture);
Builder.createAndAttachToType(CardTender.DelayCapture);
/**
 * SOURCE Reason @ squareup/client/bills/tender.proto at 842:5
 */
CardTender.DelayCapture.Reason = $root.lookupEnum('squareup.client.bills.CardTender.DelayCapture.Reason').values;
/**
 * SOURCE Authorization @ squareup/client/bills/tender.proto at 873:3
 */
CardTender.Authorization = $root.lookupType('squareup.client.bills.CardTender.Authorization');
fixType(CardTender.Authorization, {
  authorizationCode: {
    required: true
  },
  authorizedMoney: {
    required: true
  }
});
Builder.createAndAttachToType(CardTender.Authorization);
/**
 * These decline reasons provide Register the ability to drive decline-specific UX logic.
 *
 * The already provided localized_title and description provide customer/merchant feedback
 * but would be brittle for driving logic.
 *
 * NOTE: Declines that should be opaque to Register should never have a DeclineReason
 * associated with them to avoid giving attackers potentially useful information.
 *
 * SOURCE DeclineReason @ squareup/client/bills/tender.proto at 895:5
 */
CardTender.Authorization.DeclineReason = $root.lookupEnum('squareup.client.bills.CardTender.Authorization.DeclineReason').values;
/**
 * Details a server hint for signature on the client. This will only be passed
 * down for successfully authorized card tenders and should be respected by the
 * client. The value of this field should be OR'd with the existing client logic
 * for signature.
 *
 * SOURCE SignatureBehavior @ squareup/client/bills/tender.proto at 910:5
 */
CardTender.Authorization.SignatureBehavior = $root.lookupEnum('squareup.client.bills.CardTender.Authorization.SignatureBehavior').values;
/**
 * SOURCE Emv @ squareup/client/bills/tender.proto at 933:3
 */
CardTender.Emv = $root.lookupType('squareup.client.bills.CardTender.Emv');
fixType(CardTender.Emv);
Builder.createAndAttachToType(CardTender.Emv);
/**
 * The kind of processing that has already been performed for this transaction. The
 * current application for this field is to indicate when an EMV transaction has been
 * offline-processed by the reader.
 *
 * SOURCE ProcessingType @ squareup/client/bills/tender.proto at 949:5
 */
CardTender.Emv.ProcessingType = $root.lookupEnum('squareup.client.bills.CardTender.Emv.ProcessingType').values;
/**
 * SOURCE CardholderVerificationMethod @ squareup/client/bills/tender.proto at 1014:5
 */
CardTender.Emv.CardholderVerificationMethod = $root.lookupEnum('squareup.client.bills.CardTender.Emv.CardholderVerificationMethod').values;
/**
 * Which account should we draw money from.
 *
 * SOURCE AccountType @ squareup/client/bills/tender.proto at 1085:3
 */
CardTender.AccountType = $root.lookupEnum('squareup.client.bills.CardTender.AccountType').values;
/**
 * SOURCE OtherTender @ squareup/client/bills/tender.proto at 1104:1
 */
export const OtherTender = $root.lookupType('squareup.client.bills.OtherTender');
fixType(OtherTender, {
  otherTenderType: {
    required: true
  }
});
Builder.createAndAttachToType(OtherTender);
/**
 * Must map to the definitions in config/other_tenders.yml in SQ/Web.
 *
 * SOURCE OtherTenderType @ squareup/client/bills/tender.proto at 1106:3
 */
OtherTender.OtherTenderType = $root.lookupEnum('squareup.client.bills.OtherTender.OtherTenderType').values;
/**
 * ExternalMetadata is an optional field for square merchants to provide custom/other tender information
 * used by large seller / retail
 *
 * SOURCE ExternalMetadata @ squareup/client/bills/tender.proto at 1154:1
 */
export const ExternalMetadata = $root.lookupType('squareup.client.bills.ExternalMetadata');
fixType(ExternalMetadata);
Builder.createAndAttachToType(ExternalMetadata);
/**
 * Deprecated tenders or tenders that the client will not recognize.
 *
 * SOURCE GenericTender @ squareup/client/bills/tender.proto at 1163:1
 */
export const GenericTender = $root.lookupType('squareup.client.bills.GenericTender');
fixType(GenericTender);
Builder.createAndAttachToType(GenericTender);
/**
 * SOURCE NoSaleTender @ squareup/client/bills/tender.proto at 1168:1
 */
export const NoSaleTender = $root.lookupType('squareup.client.bills.NoSaleTender');
fixType(NoSaleTender);
Builder.createAndAttachToType(NoSaleTender);
/**
 * SOURCE CashTender @ squareup/client/bills/tender.proto at 1175:1
 */
export const CashTender = $root.lookupType('squareup.client.bills.CashTender');
fixType(CashTender, {
  amounts: {
    required: true
  }
});
Builder.createAndAttachToType(CashTender);
/**
 * SOURCE Amounts @ squareup/client/bills/tender.proto at 1176:3
 */
CashTender.Amounts = $root.lookupType('squareup.client.bills.CashTender.Amounts');
fixType(CashTender.Amounts, {
  buyerTenderedMoney: {
    required: true
  },
  changeBackMoney: {
    required: true
  }
});
Builder.createAndAttachToType(CashTender.Amounts);
/**
 * SOURCE WalletTender @ squareup/client/bills/tender.proto at 1188:1
 */
export const WalletTender = $root.lookupType('squareup.client.bills.WalletTender');
fixType(WalletTender);
Builder.createAndAttachToType(WalletTender);
/**
 * SOURCE ZeroAmountTender @ squareup/client/bills/tender.proto at 1192:1
 */
export const ZeroAmountTender = $root.lookupType('squareup.client.bills.ZeroAmountTender');
fixType(ZeroAmountTender);
Builder.createAndAttachToType(ZeroAmountTender);
/**
 * A payment taken + processed by an external integration (eg. Caviar) recorded in Square
 *
 * SOURCE ExternalTender @ squareup/client/bills/tender.proto at 1200:1
 */
export const ExternalTender = $root.lookupType('squareup.client.bills.ExternalTender');
fixType(ExternalTender);
Builder.createAndAttachToType(ExternalTender);
/**
 * SOURCE PaymentSource @ squareup/client/bills/tender.proto at 1201:3
 */
ExternalTender.PaymentSource = $root.lookupType('squareup.client.bills.ExternalTender.PaymentSource');
fixType(ExternalTender.PaymentSource);
Builder.createAndAttachToType(ExternalTender.PaymentSource);
/**
 * A tender where the buyer pushes money to the seller.
 *
 * SOURCE PushTender @ squareup/client/bills/tender.proto at 1223:1
 */
export const PushTender = $root.lookupType('squareup.client.bills.PushTender');
fixType(PushTender);
Builder.createAndAttachToType(PushTender);
/**
 * SOURCE EntryMethod @ squareup/client/bills/tender.proto at 1238:3
 */
PushTender.EntryMethod = $root.lookupEnum('squareup.client.bills.PushTender.EntryMethod').values;
/**
 * Using Square Cash App to pay.
 *
 * SOURCE CashAppTender @ squareup/client/bills/tender.proto at 1261:1
 */
export const CashAppTender = $root.lookupType('squareup.client.bills.CashAppTender');
fixType(CashAppTender);
Builder.createAndAttachToType(CashAppTender);
/**
 * Tender for Alipay
 *
 * SOURCE AlipayTender @ squareup/client/bills/tender.proto at 1291:1
 */
export const AlipayTender = $root.lookupType('squareup.client.bills.AlipayTender');
fixType(AlipayTender);
Builder.createAndAttachToType(AlipayTender);
/**
 * Tender for PayPay
 *
 * SOURCE PaypayTender @ squareup/client/bills/tender.proto at 1310:1
 */
export const PaypayTender = $root.lookupType('squareup.client.bills.PaypayTender');
fixType(PaypayTender);
Builder.createAndAttachToType(PaypayTender);
/**
 * Tender for Rakuten Pay
 *
 * SOURCE RakutenPayTender @ squareup/client/bills/tender.proto at 1327:1
 */
export const RakutenPayTender = $root.lookupType('squareup.client.bills.RakutenPayTender');
fixType(RakutenPayTender);
Builder.createAndAttachToType(RakutenPayTender);
/**
 * Tender for Au Pay
 *
 * SOURCE AuPayTender @ squareup/client/bills/tender.proto at 1336:1
 */
export const AuPayTender = $root.lookupType('squareup.client.bills.AuPayTender');
fixType(AuPayTender);
Builder.createAndAttachToType(AuPayTender);
/**
 * Tender for D Barai
 *
 * SOURCE DBaraiTender @ squareup/client/bills/tender.proto at 1345:1
 */
export const DBaraiTender = $root.lookupType('squareup.client.bills.DBaraiTender');
fixType(DBaraiTender);
Builder.createAndAttachToType(DBaraiTender);
/**
 * Tender for Merpay Pay
 *
 * SOURCE MerpayTender @ squareup/client/bills/tender.proto at 1354:1
 */
export const MerpayTender = $root.lookupType('squareup.client.bills.MerpayTender');
fixType(MerpayTender);
Builder.createAndAttachToType(MerpayTender);
/**
 * Tender for Wechat Pay
 *
 * SOURCE WechatPayTender @ squareup/client/bills/tender.proto at 1363:1
 */
export const WechatPayTender = $root.lookupType('squareup.client.bills.WechatPayTender');
fixType(WechatPayTender);
Builder.createAndAttachToType(WechatPayTender);
/**
 * Tender for Afterpay
 *
 * SOURCE AfterpayTender @ squareup/client/bills/tender.proto at 1372:1
 */
export const AfterpayTender = $root.lookupType('squareup.client.bills.AfterpayTender');
fixType(AfterpayTender);
Builder.createAndAttachToType(AfterpayTender);
/**
 * Payment to the seller when the buyer uses a Capital installment plan.
 *
 * SOURCE SquareCapitalTender @ squareup/client/bills/tender.proto at 1393:1
 */
export const SquareCapitalTender = $root.lookupType('squareup.client.bills.SquareCapitalTender');
fixType(SquareCapitalTender);
Builder.createAndAttachToType(SquareCapitalTender);
/**
 * SOURCE CardInstrumentDetails @ squareup/client/bills/tender.proto at 1394:3
 */
SquareCapitalTender.CardInstrumentDetails = $root.lookupType('squareup.client.bills.SquareCapitalTender.CardInstrumentDetails');
fixType(SquareCapitalTender.CardInstrumentDetails, {
  instrumentToken: {
    notEmpty: true
  },
  card: {
    required: true
  }
});
Builder.createAndAttachToType(SquareCapitalTender.CardInstrumentDetails);
/**
 * Tender for House Account
 *
 * SOURCE SquareAccountTender @ squareup/client/bills/tender.proto at 1416:1
 */
export const SquareAccountTender = $root.lookupType('squareup.client.bills.SquareAccountTender');
fixType(SquareAccountTender);
Builder.createAndAttachToType(SquareAccountTender);